export function mapLicenseCheckLatestStatusFilter(filterData) {
    const filter = [
        {
            column: 'personSystemStatus',
            op: '=',
            value: 'active',
        },
    ];
    if (filterData.search) {
        filter.push({ column: 'search', op: 'full-text-query', value: filterData.search });
    }
    if (filterData.occupationIds) {
        filter.push({
            column: 'occupationId',
            op: 'in',
            value: filterData.occupationIds,
        });
    }
    if (filterData.credentialNames) {
        filter.push({
            column: 'credentialName',
            op: 'in',
            value: filterData.credentialNames,
        });
    }
    if (filterData.statuses) {
        filter.push({
            column: 'status',
            op: 'in',
            value: filterData.statuses,
        });
    }
    if (filterData.city) {
        filter.push({
            column: 'city',
            op: '=',
            value: filterData.city,
        });
    }
    if (filterData.state) {
        filter.push({
            column: 'state',
            op: '=',
            value: filterData.state,
        });
    }
    if (filterData.county) {
        filter.push({
            column: 'county',
            op: '=',
            value: filterData.county,
        });
    }
    if (filterData.tribeId) {
        filter.push({
            column: 'tribeId',
            op: '=',
            value: filterData.tribeId,
        });
    }
    if (filterData.loginBefore) {
        filter.push({
            column: 'requestDate',
            op: '<=',
            value: filterData.loginBefore,
        });
    }
    if (filterData.loginAfter) {
        filter.push({
            column: 'requestDate',
            op: '>=',
            value: filterData.loginAfter,
        });
    }
    if (filterData.requestedBy) {
        filter.push({
            column: 'requestedBy',
            op: '=',
            value: filterData.requestedBy,
        });
    }
    if (filterData.ecls) {
        filter.push({
            column: 'ecls',
            op: 'overlap',
            value: filterData.ecls,
        });
    }
    if (filterData.occupationGroupId) {
        filter.push({
            column: 'occupationGroupId',
            op: '=',
            value: filterData.occupationGroupId,
        });
    }
    return filter;
}
